
document.addEventListener('DOMContentLoaded', () => {
  const panels = document.querySelectorAll('.product-panel');
  const io = new IntersectionObserver((entries) => {
    entries.forEach(ent => {
      if (ent.isIntersecting) {
        ent.target.setAttribute('data-sprayed','');
        setTimeout(() => ent.target.removeAttribute('data-sprayed'), 900);
        io.unobserve(ent.target);
      }
    });
  }, { threshold: 0.6 });
  panels.forEach(p => io.observe(p));
});
